import axios from "../utils/axios.wrapper";

export const getLicenses = async () => {
  const { data } = await axios.get("/license");
  return data ?? [];
};

export const getActiveLicenses = async () => {
  const { data } = await axios.get("/license/active");
  return data ?? [];
};

export const getLicenseById = async (id) => {
  const { data } = await axios.get(`/license/${id}`);
  return data;
};

export const createLicense = async (license) => {
  const { data } = await axios.post("/license", license);
  return data;
};

export const updateLicense = async (id, license) => {
  const { data } = await axios.put(`/license/${id}`, license);
  return data;
};

export const deleteLicense = async (id) => {
  const { data } = await axios.delete(`/license/${id}`);
  return data;
};
export const softDeleteLicense = async (id) => {
  const { data } = await axios.put(`/license/softdelete/${id}`);
  return data;
};

export const licenseService = {
  getLicenses,
  getActiveLicenses,
  getLicenseById,
  createLicense,
  updateLicense,
  deleteLicense,
  softDeleteLicense,
};